import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../../route';

const ShipAndDebit849ResponseDetailPage = lazyRouteComponent(
  () => import('../../849s/ShipAndDebit849ResponseDetailPage'),
  'ShipAndDebit849ResponseDetailPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/849-responses/$responseId',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SD849Response },
        ],
      },
    },
  },
  component: ShipAndDebit849ResponseDetailPage,
  validateSearch: z.object({
    lineIndex: z.coerce.number().int().min(0).optional(),
  }),
  loader: () => ({
    crumb: msg('849 Response Detail', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SD849Response,
    });
  },
});
